import client from './client';

const Objects = {
  getObjects(anketId) {
    return client.get(`/ankets/${anketId}/objects`);
  },
  getObject(anketId, objectId) {
    return client.get(`/ankets/${anketId}/objects/${objectId}`);
  },
};

export default Objects;
